import {BaseDevice} from "./base.device";
import {Inject, Injectable} from "@angular/core";
import {TokenService} from "../token/token.service";
import {HttpClient} from "@angular/common/http";
import {UserService} from "../user/user.service";
import {BASE_CLIENT, BaseClient} from "../client/base.client";
import {preloaderFinished} from "../auth/preloader";
import {Itoken} from "../auth/itoken";
import {Observable} from "rxjs";
import {IShare, ITitle, IWindow, NavigationBar, UserLocation} from "./model";
import {Title} from "@angular/platform-browser";
import {WebViewAppCommService} from "./webview-uniappx.service";

@Injectable({
  providedIn: "root",
})
export class YunzaiOaUniAppX extends BaseDevice {
  constructor(
    private tokenService: TokenService,
    private http: HttpClient,
    private user: UserService,
    private title: Title,
    private webViewAppCommService: WebViewAppCommService,
    @Inject(BASE_CLIENT) private baseclient: BaseClient
  ) {
    super();
  }

  auth(): Promise<any> {
    console.log('yunzaiOaUniAppX auth...')
    if (this.baseclient.yunzaiOaUniAppX && this.baseclient.yunzaiOaUniAppX.auth === false) {
      return new Promise<any>((resolve, reject) => {
        preloaderFinished();
        resolve(true);
      });
    }
    return new Promise<any>((resolve, reject) => {
      this.webViewAppCommService.getUserInfo().then(res => {
        const tokenInfo: any = {};
        tokenInfo.tokenType = 'bearer';
        tokenInfo.accessToken = res.token;
        // 设置token
        this.tokenService.set(tokenInfo as any);
        // 发送/user请求
        this.http
          .get(`${this.baseclient.gateway}/auth/user`)
          .subscribe((response: any) => {
            // 设置user
            this.user.set({...response.principal, tenantId: response.tenantId});
            // 加载结束
            preloaderFinished();
            resolve(true);
          });
      }).catch(err => {
        console.log(err);
        reject(err);
      })
    });
  }

  openWindow(iwindow: IWindow): void {
    // window.open(iwindow.url, '_self');
    this.webViewAppCommService.navigateTo(iwindow.url);
  }

  setTitle(ititle: ITitle): void {
    this.title.setTitle(ititle.title);
  }

  setNavigationBar(navigationBar: NavigationBar): void {
    alert("暂不支持放置按钮!");
  }

  share(ishare: IShare): void {
    alert("暂不支持分享!");
  }

  getToken(): Itoken {
    return this.tokenService.get();
  }

  scanCode(): Observable<string> {
    alert("暂不支持扫码!");
    return undefined;
  }

  userLocation(): Observable<UserLocation> {
    alert("暂不支持获取定位!");
    return undefined;
  }

  validateInWifi(bssids: string[]): Observable<boolean> {
    alert("暂不支持WIFI验证!");
    return undefined;
  }

  getWifiMac(): Observable<string> {
    alert("暂不支持获取MAC地址!");
    return undefined;
  }

  chooseContacts(count: number): Observable<any> {
    alert("暂不支持获取联系人!");
    return undefined;
  }

  contactDetails(targetUserId: string): Observable<any> {
    alert("暂不支持查询联系人详细信息!");
    return undefined;
  }

  uploadImage(count: number, sourceType: any): Observable<any> {
    alert("暂不支持图片上传!");
    return undefined;
  }

  openReadWithTimer(
    url: any,
    openType: any,
    title: any,
    id: any,
    type: any
  ): Observable<any> {
    alert("暂不支持读物时间统计!");
    return undefined;
  }

  uploadMovie(limitMinute: number): Observable<any> {
    alert("暂不支持视频上传!");
    return undefined;
  }

  fileBrowser(url: string, title: string): Observable<any> {
    alert("暂不支持此功能!");
    return undefined;
  }

  startSearchBeacons(ticket: string, callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }

  stopSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }

  onSearchBeacons(callback: (argv: any) => void): void {
    throw new Error("Method not implemented.");
  }
}
